import { render, staticRenderFns } from "./LoginIslandName.vue?vue&type=template&id=4b57c92c&"
import script from "./LoginIslandName.vue?vue&type=script&lang=js&"
export * from "./LoginIslandName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports